import debounce from 'lodash.debounce';
import SearchIcon from 'mdi-react/SearchIcon';
import React, { useEffect, useMemo, useRef, useState } from 'react';

export default function CompactTableSearch({
  value = '',
  onChange,
  placeholder = 'Search',
  autofocus = false,
  debounceMs = 300,
}) {
  const inputRef = useRef(null);
  const [localValue, setLocalValue] = useState(value);

  const emitChange = useMemo(
    () =>
      debounce((nextValue) => {
        if (onChange) {
          onChange(nextValue);
        }
      }, debounceMs),
    [onChange, debounceMs],
  );

  useEffect(() => {
    return () => {
      emitChange.cancel();
    };
  }, [emitChange]);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    if (autofocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autofocus]);

  const handleChange = (event) => {
    const nextValue = event.target.value;
    setLocalValue(nextValue);
    emitChange(nextValue);
  };

  const handleClear = () => {
    emitChange.cancel();
    setLocalValue('');
    if (onChange) {
      onChange('');
    }
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className="table-toolbar__search">
      <span className="table-toolbar__search-icon" aria-hidden="true">
        <SearchIcon />
      </span>
      <input
        ref={inputRef}
        type="text"
        className="table-toolbar__search-input"
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        name="table-toolbar-search"
        aria-label="Search"
      />
      {localValue ? (
        <button
          type="button"
          className="table-toolbar__search-clear"
          onClick={handleClear}
          aria-label="Clear search"
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
